var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.44 31.6a5.282 5.282 0 0 1-1.35-.18l-14.86-4a5.18 5.18 0 0 1-3.83-5V5.58a5.17 5.17 0 0 1 6.51-5l14.86 4a5.19 5.19 0 0 1 3.84 5v16.84a5.18 5.18 0 0 1-5.17 5.18ZM8.56 1.6a4 4 0 0 0-4 4v16.84a4 4 0 0 0 2.94 3.84l14.86 4a4 4 0 0 0 5-3.84V9.56a4 4 0 0 0-2.94-3.84L9.6 1.74a4.19 4.19 0 0 0-1.04-.14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 25.94-6-11.46 4.86-5.05a.6.6 0 0 0 0-.85.61.61 0 0 0-.85 0l-4.58 4.76-3.6-6.84a.65.65 0 0 0-.37-.3l-3.63-1a.6.6 0 0 0-.63.2.59.59 0 0 0-.12.6l5.42 10.3-5.55 5.81a.6.6 0 0 0 0 .85.62.62 0 0 0 .85 0l5.34-5.5 4.21 8a.63.63 0 0 0 .36.3l3.64 1c.055.01.113.01.17 0a.598.598 0 0 0 .46-.22.61.61 0 0 0 .02-.6Zm-3.76-1.27-9.45-18 2 .59 9.45 18-2-.59Z",
    fill: "currentColor"
  })));
};

export default SvgTwitter;